import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import classNames from 'classnames';

import { isProd } from '../../../../../config/config';
import { TRASHIE_STRIPE_PUBLIC_KEY } from '../../../config/config';
import { formatCurrencyNumber } from '../../../utils/numbers';

import './StripeCustomCheckout.scss';

const stripePromise = loadStripe(
  isProd()
    ? TRASHIE_STRIPE_PUBLIC_KEY.PRODUCTION
    : TRASHIE_STRIPE_PUBLIC_KEY.TEST,
);

const StripeCustomCheckout = ({
  clientSecret,
  fullValue,
  discountedValue,
  isCouponApplied,
  disabled,
  className,
  priceClassName,
  fullValueClassName,
  discountedValueClassName,
}) => {
  if (!clientSecret) {
    return null;
  }

  return (
    <div className={classNames('stripeCustomCheckout', className)}>
      <div className="stripeCustomCheckout__container">
        {isCouponApplied && discountedValue != null && (
          <div className={classNames('stripeCustomCheckout__container--coupon-price-container', priceClassName)}>
            {fullValue && (
              <div className={classNames('stripeCustomCheckout__container--coupon-price-container-StrikeValue', fullValueClassName)}>
                {formatCurrencyNumber(fullValue)}
              </div>
            )}
            <div className={classNames('stripeCustomCheckout__container--coupon-price-container-value', discountedValueClassName)}>
              {formatCurrencyNumber(discountedValue)}
            </div>
          </div>
        )}
        {clientSecret && (
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret }}
          >
            <EmbeddedCheckout
              className={classNames('stripeCustomCheckout__embeddedCheckout', { disabled })}
            />
          </EmbeddedCheckoutProvider>
        )}
      </div>
    </div>
  );
};

export default StripeCustomCheckout;
